// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_vx";
export var lbContainerInner = "B_vy";
export var movingForwards = "B_vz";
export var movingForwardsOther = "B_vB";
export var movingBackwards = "B_vC";
export var movingBackwardsOther = "B_vD";
export var lbImage = "B_vF";
export var lbOtherImage = "B_vG";
export var prevButton = "B_vH";
export var nextButton = "B_vJ";
export var closing = "B_vK";
export var appear = "B_vL";